<!-- 召回通知单列表 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField"
                                                          :prop="formOneValue.entityField"
                                                          :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <el-tooltip class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' || sendDataInfo[formOneValue.entityField].length <= 9 ? true : false"
                                                            effect="dark" :content="getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)"
                                                            placement="bottom-start">
                                                    <!-- 库房 -->
                                                    <el-select filterable v-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                                        <el-option v-for="(storageRoomValue, storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- <el-input v-else-if="formOneValue.entityField == 'bgmCode'" clearable v-model="sendDataInfo[formOneValue.entityField]"
                                                 :disabled="formOneValue.isChange == 0||(formOneValue.isUpdate==0&&dataActionBox.actionType >= 1)"></el-input> -->
                                                    <!-- 商品编码 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgmCode'" clearable v-model="sendDataInfo[formOneValue.entityField]"
                                                              :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType >= 1)">
                                                        <el-button :disabled="formOneValue.isChange == 0 || (formOneValue.isUpdate == 0 && dataActionBox.actionType >= 1)" slot="append" @click="openCodePrefixDialog"
                                                                   type="primary" size="mini">获取最新编号</el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.fieldType == 'search'" clearable @clear="clear(formOneValue.setField, formOneValue.entityField)"
                                                              v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0">
                                                        </el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'ggmInitunit'" clearable :disabled="formOneValue.isChange == 0" v-model="sendDataInfo.ggmInitunitName"
                                                              @focus="openSearch(formOneValue.searchId, 0, 'ggmInitunit')">
                                                    </el-input>
                                                    <!-- <df-date v-else-if="formOneValue.fieldType == 'date'" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType==2" v-model="sendDataInfo[formOneValue.entityField]" /> -->

                                                    <!-- 备注 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgmRemarks'" type="textarea" clearable v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                                    <!-- 手术类型 -->
                                                    <div class="cmContent" v-else-if="formOneValue.entityField == 'bgiSurgeryType'">
                                                        <el-button v-if="dataActionBox.actionType < 2" class="cmButton" @click="openRange('手术类型', 'bgiSurgeryType')" type="info" plain size="mini">选择手术类型</el-button>
                                                        <el-input type="textarea" v-model="obj.bgiSurgeryTypeNames" readonly>
                                                        </el-input>
                                                    </div>
                                                    <!-- 长 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMinilength'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 宽 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMiniwidth'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 高 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMiniheight'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 体积 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMinivolume'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">立方厘米（cm3）</template>
                                                    </el-input>
                                                    <!-- 重量 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'bgpMiniweight'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">克（g）</template>
                                                    </el-input>
                                                    <!-- 包装单位 -->
                                                    <el-select filterable clearable v-else-if="formOneValue.entityField == 'bgpUnitmeasurement'" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in dictionariesData.BZDW" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 大包装 -->
                                                    <el-select filterable clearable v-else-if="formOneValue.entityField == 'largePackage'" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in dictionariesData.DBZ" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 装箱规格 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'packingSpec'" @blur="number($event)" v-model.number="sendDataInfo[formOneValue.entityField]" type="number" min="0"
                                                              @keydown.up.native="increase" @keydown.down.native="decrease">
                                                    </el-input>

                                                    <!-- 编号分类 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'codeType'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in codeClassify" :key="dictionariesKey" :label="dictionariesValue.codeType"
                                                                   :value="dictionariesValue.codeType">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 养护类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiCurtype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.yhlx" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 剂型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiDromodel'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue) in dictionariesData.jx" :key="dictionariesValue.diValue" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 处方类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiPretype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cflx" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 质量标准 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiQuatype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.zlbz" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 产品线分类 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiLineClass'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in baseprolineList" :key="dictionariesKey" :label="dictionariesValue.bgiLineClass"
                                                                   :value="dictionariesValue.bgiLineClass">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 存储类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiStocondition'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cctj" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 运输类型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'transMode'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.YSLX" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 剂型 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiProrange'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.p" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 经营范围 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiManrange'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.m" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 诊疗范围 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'bgiTrerange'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.z" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 集采分类 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'collectClassify'" filterable v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.CJFL" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                                                             :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 3 || dataActionBox.actionType == 4">
                                                    </df-date>
                                                    <!-- 是否冷藏 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIscoldstorage'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <!-- 是否唯一值 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'isOnly'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <!-- 是否双人验收 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIsdcheck'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否双人复核 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIsdreview'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否电子监管码 -->
                                                    <el-radio-group v-else-if="formOneValue.entityField == 'bgiIsesupervise'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <el-radio-group v-else-if="formOneValue.fieldType == 'radio'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button v-for="(item,index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="item.value">{{item.key}}</el-radio-button>
                                                    </el-radio-group>
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'dlType'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="cwflChange"
                                                               :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.DLLX" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 税务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'taxname'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="taxChange"
                                                               :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.swflmc" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 财务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'financialName'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="cwflChange"
                                                               :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cwfl" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                                   :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField == 'suggestedPrice'" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                              :disabled="formOneValue.isChange == 0" @input="validateInput('suggestedPrice')"></el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'lowestPrice'" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                              :disabled="formOneValue.isChange == 0" @input="validateInput('lowestPrice')"></el-input>

                                                    <el-input v-else-if="formOneValue.entityField == 'validPeriod'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0"
                                                              @input="numInput(formOneValue.entityField)">
                                                        <template slot="append">个月</template>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'bgiMainfunction'" type="textarea" :maxlength="$store.state.inputLength"
                                                              v-model="sendDataInfo[formOneValue.entityField]">
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'bgiQuanumber'" type="textarea" v-model="sendDataInfo[formOneValue.entityField]">
                                                    </el-input>
                                                    <el-select clearable size="mini" filterable v-else-if="formOneValue.entityField == 'bgiType'" @change="changesmIntype" v-model="sendDataInfo[formOneValue.entityField]"
                                                               placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                    </el-select>
                                                    <el-date-picker v-else-if="formOneValue.entityField == 'planTime'" v-model="sendDataInfo[formOneValue.entityField]" type="date" value-format="timestamp" placeholder="选择日期">
                                                    </el-date-picker>
                                                    <el-select clearable size="mini" filterable v-else-if="formOneValue.fieldType == 'formatter'" @change="((val) => { handleChange(val, formOneValue.entityField) })"
                                                               v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key"
                                                                   :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                                   :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                                    </el-select>
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" @blur="blurChange(formOneValue.entityField)"></el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                    {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,
                                          formOneValue.fieldType, formOneValue.formatterContent) }}
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "basicsgoodAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            seType: "",
            seIndex: "",
            sField: "", // 赋值字段
            fField: "", //焦点字段
            parentSearchData: {},
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            requesUrl: "",
            token: {
                token: sessionStorage.getItem("token"),
            },
            inputel: [],
            rangeObj: {}, //范围对象
            storageRoomList: [],
            dictionariesData: [],

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'stId') {
                if (this.storageRoomList) {
                    this.storageRoomList.forEach(item => {
                        if (item.stId == val) {
                            str = item.stName
                        }
                    })
                }
            } else if (type == 'dlType') {
                if (this.dictionariesData.DLLX) {
                    this.dictionariesData.DLLX.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiLineClass') {
                if (this.baseprolineList) {
                    this.baseprolineList.forEach(item => {
                        if (item.bgiLineClass == val) {
                            str = item.bgiLineClass
                        }
                    })
                }
            } else if (type == 'bgpUnitmeasurement') {
                if (this.dictionariesData.BZDW) {
                    this.dictionariesData.BZDW.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'collectClassify') {
                if (this.dictionariesData.CJFL) {
                    this.dictionariesData.CJFL.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'largePackage') {
                if (this.dictionariesData.DBZ) {
                    this.dictionariesData.DBZ.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiCurtype') {
                if (this.dictionariesData.yhlx) {
                    this.dictionariesData.yhlx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiDromodel') {
                if (this.dictionariesData.jx) {
                    this.dictionariesData.jx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiPretype') {
                if (this.dictionariesData.cflx) {
                    this.dictionariesData.cflx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiQuatype') {
                if (this.dictionariesData.zlbz) {
                    this.dictionariesData.zlbz.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiStocondition') {
                if (this.dictionariesData.cctj) {
                    this.dictionariesData.cctj.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'transMode') {
                if (this.dictionariesData.YSLX) {
                    this.dictionariesData.YSLX.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiProrange') {
                if (this.rangeObj.p) {
                    this.rangeObj.p.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'bgiManrange') {
                if (this.rangeObj.m) {
                    this.rangeObj.m.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'bgiTrerange') {
                if (this.rangeObj.z) {
                    this.rangeObj.z.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'financialName') {
                if (this.dictionariesData.cwfl) {
                    this.dictionariesData.cwfl.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        increase(event) {
            // 阻止默认行为
            event.preventDefault();
        },
        decrease(event) {
            event.preventDefault();
        },
        numInput(entityField) {
            console.log(this.sendDataInfo[entityField]);
            var str = JSON.parse(JSON.stringify(this.sendDataInfo[entityField]))
            var arr = str.split("")
            const regex = /^\d+(\.\d+)?$/;
            if (!regex.test(str)) {
                arr.forEach((item, index) => {
                    if (!regex.test(str[index]) && item != ".") {
                        arr.splice(index, 1)
                    }
                })
            }
            var strText = ""
            arr.forEach(item => {
                strText = strText + item
            })
            this.sendDataInfo[entityField] = strText
        },
        //可输入(小数或整数)
        validateInput(entityField) {
            // 正则表达式匹配整数或小数
            const regex = /^\d+(\.\d+)?$/;
            // 检查输入值是否匹配正则表达式
            if (!regex.test(this.sendDataInfo[entityField])) {
                // 如果不匹配，则替换掉非法字符，只保留数字和小数点
                this.sendDataInfo[entityField] = this.sendDataInfo[entityField].replace(/[^\d.]/g, '');
                // 如果需要，可以在这里添加逻辑来定位光标到最后一个合法字符之后
            } else {
            }
            if (String(this.sendDataInfo[entityField]).indexOf(".") != -1) {
                var strNum = String(this.sendDataInfo[entityField]).indexOf(".")
                if (String(this.sendDataInfo[entityField]).length - 1 - strNum > 10) {
                    this.sendDataInfo[entityField] = this.$common.getDecimalInfo(2, this.sendDataInfo[entityField])
                }
            }
        },
        // 下拉赋值
        handleChange(value, name) {
            this.sendDataInfo[name] = value;
            if (name == 'isExpi') {
                var arr = this.tabForm.filter(item => item.jciId == 1077687)
                if (this.sendDataInfo[name] == 1) {
                    arr[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'validPeriod') {
                            item.isRequired = 1
                        }
                    })
                } else {
                    arr[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'validPeriod') {
                            item.isRequired = 0
                        }
                    })
                }
            }

        },
        //税务名称改变
        taxChange(data) {
            console.log("data", data);
            for (let i = 0; i < this.dictionariesData.swflmc.length; i++) {
                const item = this.dictionariesData.swflmc[i];
                if (item.diName == data) {
                    this.sendDataInfo.taxnumber = item.diCode;
                    break;
                }
            }
        },
        //税务名称改变
        cwflChange(data) {
            for (let i = 0; i < this.dictionariesData.cwfl.length; i++) {
                const item = this.dictionariesData.cwfl[i];
                if (item.diName == data) {
                    this.sendDataInfo.financialCode = item.diCode;
                    break;
                }
            }
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            this.DialogVisible = false;
            if (val && (val != "" || val != undefined)) {
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val, flag) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.$set(this.sendDataInfo, item, val[item])
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            this.parentSearchData = {}
            if (type == 'salesName') {
                if (this.sendDataInfo.cmId == '' || this.sendDataInfo.cmId == null) {
                    return this.$message.error("请先选择客户");
                }
                this.parentSearchData.unitId = this.sendDataInfo.cmId;
            }
            if (type == 'opmName') {
                this.parentSearchData.opmSalesperson = 1
                this.parentSearchData.opmBuyer = ""
            }
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },


        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消关闭'
                    // });
                });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";

                var dataInfo = JSON.parse(JSON.stringify(oldData));

                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.sendDataInfo.rcnId = dataInfo.rcnId
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        sendDataAction(sendDataInfo) {
            console.log(sendDataInfo);
            this.$refs.sendDataInfo.validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.sysBasicsgoodadd(sendData);
            } else {
                var responseData = await this.$http.sysBasicsgoodupdate(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message.success("操作成功");
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });

                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var arr = [];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
        //获取生产/经营范围
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByTypeByOrm(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取诊疗范围
        async getQueryScopeByTypeZhenLiao(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getGspStorageRoom();

            if (responseData.status == 200) {
                this.storageRoomList = responseData.result;
                if (this.storageRoomList.length != 0 && (this.dataActionBox.actionType == 0 || this.dataActionBox == 4)) {
                    //赋个默认值,defaultValue的值过滤 可用库房列表 
                    console.log(this.tabForm, this.storageRoomList, "库房！！！！！！！")
                    this.tabForm[0].jurconfigform.forEach(item => {
                        if (item.entityField == 'stId') {
                            if (item.defaultValue !== "" && item.defaultValue != null) {
                                let isGiveValue = false
                                this.storageRoomList.forEach(e => {
                                    if (e.stName == item.defaultValue) {
                                        this.sendDataInfo.stId = e.stId
                                        isGiveValue = true
                                    }
                                })
                                if (!isGiveValue) {
                                    this.sendDataInfo.stId = this.storageRoomList[0].stId
                                }
                            } else {
                                this.getGoodStRule()
                                this.sendDataInfo.stId = this.storageRoomList[0].stId
                            }
                        }
                    })
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [14, 10, 9, 25, 11, 13, 5, 30, 39, 41, 42, 43, 58, 61, 62, 65],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();
        this.$nextTick(async () => {
            this.openBox();
            this.getAllStorageRoom();
            this.isLoaded = true;
            //type 范围类型0.生产范围1.经营范围
            await this.getQueryScopeByType(0).then((res) => {
                this.$set(this.rangeObj, "p", res);
            });
            await this.getQueryScopeByType(1).then((res) => {
                this.$set(this.rangeObj, "m", res);
            });
            await this.getQueryScopeByTypeZhenLiao(2).then((res) => {
                this.$set(this.rangeObj, "z", res);
            });

        });
        this.getPartDictionariesData();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>